import makeStyles from '@mui/styles/makeStyles';

export const MainStyle = makeStyles((theme) => ({
	main: {
		minHeight: "100vh",
		/*display: "grid",
		 gridTemplateColumns: "80px 0.7fr 0.3fr",
		 gridTemplateRows: "1fr",*/
		backgroundColor: theme.palette.mode === "light" ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.3)",
	},
	mainTest: {
		minHeight: "100vh",
		display: "grid",
		gridTemplateColumns: "80px 0.7fr 0.3fr",
		gridTemplateRows: "1fr",
		backgroundColor: theme.palette.mode === "light" ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.8)",
	},
	section1: {
		display: "grid",
		gridTemplateRows: "70px 1fr 70px",
		height: "100vh",
		//background: "linear-gradient(25deg, rgba(0,212,255,1) 0%, rgba(81,168,255,1) 50%,
		// rgba(0,122,249,0.8578781854538691) 100%)",
		/*backgroundColor: "rgba(0,0,0,0.1)",*/
		/*borderRadius: "0 30px 30px 0",*/
	},
	section2: {
		height: "100vh",
		display: "grid",
		gridTemplateRows: "210px 40px 1fr",
		/*backgroundColor: indigo["A100"],*/
	},
	section3: {
		height: "100vh",
		display: "grid",
		gridTemplateRows: "210px 1fr",
	},
	menuWrapper: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "center",
	},
	settings: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "center",
		marginBottom: theme.spacing(2)
	},
	menu: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	selectedMenu: {
		backgroundColor: "rgba(0,0,0,0.04)",
		//color: "#FFF",
		borderRadius: "0 30px 30px 0",
		marginLeft: -15,
		paddingLeft: 33,
		paddingRight: 20,
	},
	logo: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "center",
		width: 50,
		padding: theme.spacing(2)
	},
	hello: {
		padding: theme.spacing(6, 0, 6, 5),
		fontWeight: "bolder",
		color: theme.palette.mode === "light" ? "#000" : "#FFF"
	},
	actionDetailTitle: {
		padding: theme.spacing(4, 0, 0, 5),
		fontWeight: "bolder",
		color: theme.palette.mode === "light" ? "#000" : "#FFF"
	},
	sectionTitle: {
		padding: theme.spacing(0, 2, 2, 5),
		fontWeight: "bolder",
		color: theme.palette.mode === "light" ? "#000" : "#FFF",
		'&:hover': {
			cursor: "pointer"
		},
	},
	sectionTitleRight: {
		padding: theme.spacing(0, 2, 2, 0),
		fontWeight: "bolder",
		color: theme.palette.mode === "light" ? "#000" : "#FFF"
	},
	actionSections: {
		padding: theme.spacing(4),
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "flex-start",
		overflowY: "scroll",
		scrollbarWidth: "none", // Nasconde la scrollbar in Firefox
		"&::-webkit-scrollbar": {
			display: "none", // Nasconde la scrollbar in WebKit
		},
	},
	actionSectionsScuole: {
		padding: theme.spacing(3, 4, 2, 4),
	},
	action: {
		margin: theme.spacing(1),
		border: "1px solid rgba(0,0,0,0.1)",
		/*background: "linear-gradient(25deg, rgba(0,212,255,1) 0%, rgba(81,168,255,1) 50%, rgba(0,122,249,0.8578781854538691) 100%)",*/
		/*backgroundColor: "rgba(0,0,0,0.1)",*/
		width: 200,
		height: 260,
		borderRadius: 30,
		transition: "transform .2s",
		'&:hover': {
			transform: "scale(1.04)",
			boxShadow: "5px 5px 15px 8px rgba(0,0,0,0.22)"
		},
	},
	actionArea: {
		width: "100%",
		height: "100%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
	},
	actionTitle: {
		padding: theme.spacing(2, 2, 1, 2),
		fontWeight: "bolder",
		textAlign: "center",
	},
	actionSubtitle: {
		padding: theme.spacing(1),
	},
	actionImage: {
		width: 80,
		padding: theme.spacing(2),
	},
	userSection: {
		display: "flex",
		flexDirection: "row-reverse",
	},
	profileWrapper: {
		margin: theme.spacing(2, 4, 2, 2),
		width: 50,
		height: 50,
	},
	profile: {
		width: 50,
		height: 50,
	},
	notification: {
		margin: theme.spacing(2, 0, 2, 2),
		width: 50,
		height: 50,
		color: theme.palette.mode === "light" ? "#000" : "#FFF"
	},
	calendarSection: {
		color: theme.palette.mode === "light" ? "#000" : "#FFF"
	}
}));
